import * as React from 'react'

import Button               from '@material-ui/core/Button'
import Dialog               from '@material-ui/core/Dialog'
import DialogActions        from '@material-ui/core/DialogActions'
import DialogContent        from '@material-ui/core/DialogContent'
import DialogTitle          from '@material-ui/core/DialogTitle'
import FormControlLabel     from '@material-ui/core/FormControlLabel'
import Radio                from '@material-ui/core/Radio'
import RadioGroup           from '@material-ui/core/RadioGroup'
import { FormattedMessage } from 'react-intl'

import testingHooks from '../../testing-hooks'

export interface OpenerComponentProps {
  open: () => void
}

export interface Option {
  name: string
  value: any
}

export interface SelectDialogProps {
  onSave: (value: any) => void
  children: (props: OpenerComponentProps) => JSX.Element
  options: Option []
  initialSelected?: any
}

interface SelectDialogState {
  isDialogOpen: boolean
  selectedValue: any
}

class SelectDialog extends React.Component<SelectDialogProps, SelectDialogState> {
  public state = {
    isDialogOpen:  false,
    selectedValue: this.props.initialSelected,
  }

  public render () {
    const { children } = this.props

    return (
      <>
        {children({ open: this.toggleOpen })}
        {this.renderDialog()}
      </>
    )
  }

  private renderDialog () {
    const {
      isDialogOpen,
      selectedValue,
    } = this.state

    const {
      options,
    } = this.props

    return (
      <Dialog
        open={isDialogOpen}
        onClose={this.toggleOpen}
      >
        <DialogTitle>
          <FormattedMessage
            id={'generic.selectPreferredLanguage'}
            defaultMessage={'Select your preferred language'}
          />
        </DialogTitle>
        <DialogContent style={{ minWidth: '400px' }}>
          <RadioGroup
            value={selectedValue}
            onChange={this.changeSelectedValue}
          >
            {options.map(({ name, value }) => (
              <FormControlLabel
                value={value}
                key={name}
                control={<Radio/>}
                label={name}
              />
            ))}
          </RadioGroup>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={this.toggleOpen}
            color="primary"
            data-test-id={testingHooks.buttons.cancel}
          >
            <FormattedMessage
              id={'buttonActions.cancel'}
              defaultMessage={'cancel'}
            />
          </Button>
          <Button
            onClick={this.select}
            color="primary"
            data-test-id={testingHooks.buttons.save}
          >
            <FormattedMessage
              id={'buttonActions.save'}
              defaultMessage={'save'}
            />
          </Button>
        </DialogActions>
      </Dialog>
    )
  }

  private select = () => {
    this.props.onSave(this.state.selectedValue)
    this.setState({
      isDialogOpen: false,
    })
  }

  private changeSelectedValue = (e: any, value: any) => {
    this.setState({
      selectedValue: value,
    })
  }

  private toggleOpen = () => {
    this.setState(state => ({
      isDialogOpen: !state.isDialogOpen,
    }))
  }
}

export default SelectDialog



// WEBPACK FOOTER //
// ./src/components/molecules/SelectDialog.tsx